import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';

const propTypes = {
  leftContent: PropTypes.element,
  rightContent: PropTypes.element,
  sectionClassName: PropTypes.string,
  rightClassName: PropTypes.string,
  leftClassName: PropTypes.string,
};

const defaultProps = {
  leftContent: <div />,
  rightContent: <div />,
  sectionClassName: '',
  rightClassName: '',
  leftClassName: '',
};

const TwoColLayout = ({ leftContent, rightContent, sectionClassName, rightClassName, leftClassName }) => (
  <div className={cx('two-col-middle-spacing', sectionClassName)}>
    <div className="row collapse">
      <div className="column medium-6">
        <div className={cx('left-column', leftClassName)}>
          {leftContent}
        </div>
      </div>
      <div className="column medium-6">
        <div className={cx('right-column', rightClassName)}>
          {rightContent}
        </div>
      </div>
    </div>
  </div>
);

TwoColLayout.propTypes = propTypes;
TwoColLayout.defaultProps = defaultProps;
export default TwoColLayout;
